// Small IST/date helpers. Backend stores result_date as YYYY-MM-DD (IST).
export function formatDate(iso, opts = {}) {
  if (!iso) return "";
  const [y, m, d] = iso.split("-").map(Number);
  const date = new Date(Date.UTC(y, m - 1, d));
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
    ...opts,
  });
}

export function formatTime24to12(hhmm) {
  if (!hhmm) return "";
  const [h, m] = hhmm.split(":").map(Number);
  const ampm = h >= 12 ? "PM" : "AM";
  const hh = ((h + 11) % 12) + 1;
  return `${hh}:${String(m).padStart(2, "0")} ${ampm}`;
}

// Get "now" in IST as {y, m, d, h, min, iso: "YYYY-MM-DD"}
export function nowIST() {
  const now = new Date();
  const utc = now.getTime() + now.getTimezoneOffset() * 60000;
  const ist = new Date(utc + 5.5 * 60 * 60 * 1000);
  return {
    date: ist,
    y: ist.getFullYear(),
    m: ist.getMonth() + 1,
    d: ist.getDate(),
    h: ist.getHours(),
    min: ist.getMinutes(),
    iso: `${ist.getFullYear()}-${String(ist.getMonth() + 1).padStart(2, "0")}-${String(ist.getDate()).padStart(2, "0")}`,
  };
}

export const todayIST = () => nowIST().iso;

function isoOfDate(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

/**
 * Result cycle date for a game — used for card display of "current cycle".
 * Overnight night games (FR 20:xx-23:xx and SR before 06:00): between midnight
 * and (SR+30min), the current cycle still belongs to the previous IST date.
 */
export function cycleDateIST(game) {
  const { h, min, iso, date } = nowIST();
  if (!game) return iso;
  const [srH, srM] = (game.sr_time || "").split(":").map(Number);
  const isOvernight = srH < 6 && (game.fr_time || "").startsWith("2");
  if (isOvernight) {
    const nowMin = h * 60 + min;
    const srMin = srH * 60 + srM + 30;
    if (nowMin < srMin) {
      const prev = new Date(date);
      prev.setDate(prev.getDate() - 1);
      return isoOfDate(prev);
    }
  }
  return iso;
}

/**
 * Common-Number "for-date" — the daily rollover date shown on the CN page.
 *  - Morning / Day games: rolls to next day at 20:00 IST.
 *  - Night games:         rolls to next day at 01:00 IST (so between 00:00 and 01:00 still shows previous day).
 */
export function commonNumberDate(game) {
  const { h, date } = nowIST();
  if (!game) return isoOfDate(date);
  const d = new Date(date);
  const isNight = game.color_family === "night" || /night/i.test(game.name);
  if (isNight) {
    if (h < 1) d.setDate(d.getDate() - 1);
  } else {
    if (h >= 20) d.setDate(d.getDate() + 1);
  }
  return isoOfDate(d);
}
